App.factory('validationHelper', ['$http', '$q', '$location', '$rootScope', '$route', function($http, $q, $location, $rootScope, $route) {
	var validationHelper = {};

	validationHelper.validateFormVerify = function($scope, ngForm) {
        return this.validatePin($scope, ngForm, false);
    };

    validationHelper.validate = function($scope,billnow) {

    	//im gonna set cookies here, but could happen somewhere else, maybe at each step
    	/*-----------------*/
		var date = new Date();
		var minutes = 120;
		date.setTime(date.getTime() + (minutes * 60 * 1000));


		/////// remove the cookies if they exist //////////
		$.cookie("pop_domain", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_firstname", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_lastname", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_username", "",{ path: '/', expires: -5, domain: '.pop.co' });
		$.cookie("pop_comm_pref", "",{ path: '/', expires: -5, domain: '.pop.co' });

		if($scope.formData.comm_pref == "email")
		{
			$.cookie("pop_comm_email", "",{ path: '/', expires: -5, domain: '.pop.co' });
		} else {
			$.cookie("pop_comm_cell", "",{ path: '/', expires: -5, domain: '.pop.co' });
		}
		//////////////////////////////////////////////////

		$.cookie("pop_domain", $scope.selectedDomain.Domain, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_firstname", $scope.formData.firstname, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_lastname", $scope.formData.lastname, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_username", $scope.formData.username, { path: '/', expires: date, domain: '.pop.co' });
		$.cookie("pop_comm_pref",$scope.formData.comm_pref, {path: '/', expires:date, domain: '.pop.co'});

		/*-----------------*/

    	if (!$scope.showResendMessage) {
            return this.validateRegistration($scope,billnow);
        } else {
            return this.resendVerification($scope);
        }
    }

    /**
     * The over-arching handling for validating email and mobile forms. This is
     * the initiation of a registration in which a PIN is generated and sent
     * to the user via their preferred registration method.
     */
    validationHelper.validateRegistration = function($scope, billnow) {
        var deferred = $q.defer(),
            data = angular.copy($scope.formData);

        void 0;

        // add cookie to data
        data.utmz_cookie = JSON.stringify($.cookie());

        // check for other interesting data to send
        data.coupon_code = $.cookie('coupon_code');
        data.coupon_code = data.coupon_code || null;
        data.tracking_code = $.cookie('tracking_code');
        data.tracking_code = data.tracking_code || null;
        data.domain = $scope.selectedDomain.Domain;
        //data.confirm_terms = false;

		var bundle = $scope.currentBundle;

        data.bundle = $scope.selectedDomain.TLD === 'co' ? 'candy-bundle' : $scope.selectedDomain.TLD +'-bundle';
		
		data.services = { domain: 'domain-'+ $scope.selectedDomain.TLD +'-bundle'  };

		if($rootScope.modalServiceSignup !== true)
		{
			if($scope.selectedEmail != null && $scope.selectedEmail == 'atmail')
			{
				data.services.atmail = 'atmail-free';
			}
		}

        $scope.ajax = true;

        void 0;
        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/validate', data)
            .success(function(response) {

            	$scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    // empty params
                    POP.params = {};

                    // user no longer needs to use resend since they failed
                    $scope.showResendMessage = false;

                    // handle rejection
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                	//Add any msg to the pin errors, even though its not an error
                	//$scope.pinErrors.push(response.msg);

                    // update POP params
                    POP.params = response.data;

					// set the domain and signup token
					POP.logEvent('signup', 'verified', response.data.email);

                    // user must now use resend pin functionality
                    $scope.showResendMessage = true;

                    // set pertinent cookies if we're logging in
                    if (response.data.percolate) {
                        validationHelper.loadPercolator(response.data);
                    }

                    // resolve with response data
                    deferred.resolve(response);
                }
            })
            .error(function(response) {

            	$scope.ajax = false;

                void 0;
                void 0;

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred.'
                });
            });

        // return the promise
        return deferred.promise;
    };

    /**
     * Handle resending verification. This assumes the user already made an
     * attempt and it didn't go through.
     */
    validationHelper.resendVerification = function($scope) {
        var deferred = $q.defer(),
            data = angular.copy($scope.formData);

        $scope.ajax = true;

        void 0;

        data = _.extend(data, {
            domain: $scope.selectedDomain.Domain,
            comm_pref: data.comm_pref,
            comm_email: data.comm_email,
            cell: data.cell,
            cell_countrycode: data.cell_countrycode,
            cell_countrycode_numeric: data.cell_countrycode_numeric,
			domain: $scope.selectedDomain.Domain
        });

        void 0;
        void 0;

        // handle the attempted registration with form data
        $http
            .post(POP.apiBaseUrl + '/register/resend/', data)
            .success(function(response) {
                var key;

                $scope.ajax = false;

                void 0;
                void 0;

                // check for errors
                if (!response || !response.code || response.code != 200) {
                    validationHelper.generateRejectResponse($scope, deferred, response);
                } else {
                    // update POP params
                    POP.params.token = response.data.token;

                    // set token
                    $scope.formData.token = response.data.token;

                    var date = new Date();
					var minutes = 120;
					date.setTime(date.getTime() + (minutes * 60 * 1000));
                    $.cookie("pop_registration_token",$scope.formData.token, {path: '/', expires:date, domain: '.pop.co'});

                    deferred.resolve(response);
                }
            })
            .error(function(response) {

            	$scope.ajax = false;

                void 0;
                void 0;

                deferred.reject({
                    code: 500,
                    msg: 'An error occurred.'
                });
            });

        // return the promise
        return deferred.promise;
    };

    /**
     * Special case to validate the PIN on form submission and not on clicking
     * nextStep like the rest of the fields.
     */
    validationHelper.validatePin = function($scope, isTest) {
        var deferred = $q.defer(),
            field,
			data = angular.copy($scope.formData),
            key;

        void 0;
        void 0;
        void 0;
        void 0;
        void 0;

        $scope.ajax = true;

		data.domain = $scope.selectedDomain.Domain;

		var bundle = $scope.currentBundle;

        data.bundle = $scope.selectedDomain.TLD === 'co' ? 'candy-bundle' : $scope.selectedDomain.TLD +'-bundle';
		
		data.services = { domain: 'domain-'+ $scope.selectedDomain.TLD +'-bundle'  };

		if($rootScope.modalServiceSignup !== true)
		{
			if($scope.selectedEmail != null && $scope.selectedEmail == 'atmail')
			{
				data.services.atmail = 'atmail-free';
			}
		}

        $http.post(
            POP.apiBaseUrl + '/register/validate/pin',data)
        .success(function(response) {

        	$scope.ajax = false;

            void 0;
            void 0;

            if (response.code == 200) {
            	/******************************* All manners of tracking ************************/
                if (typeof _gaq != 'undefined') {
                    _gaq.push(['_trackPageview', 'activation-registration-initialized']);
                }

                if (typeof _kmq != 'undefined') {
	                _kmq.push(['identify', $scope.selectedDomain.Domain]);
	            }

	            $('.step-5-verified').trigger('click');
	            /*********************************************************************************/

                $scope.formData.pin_validated = $scope.formData.pin;

                // set data as POP params
                POP.params = response.data;

                // set the domain and signup token
                POP.logEvent('signup', 'verified', response.data.email);

                //show success message, or at least a progress indicator
                $scope.validPin = true;

                // set pertinent cookies if we're logging in
                if (response.data.percolate) {
                    validationHelper.loadPercolator(response.data);
                }

			   	deferred.resolve(response);
            } else {
                // ensure next button is disabled
                $scope.formData.pin_validated = '';

                validationHelper.generateRejectResponse($scope, deferred, response);
            }
        }).error(function(response) {

        	$scope.ajax = false;

            void 0;
            void 0;

            deferred.reject({
                code: 500,
                msg: 'An error occurred.'
            });
        });

        return deferred.promise;
    };

    validationHelper.loadPercolator = function(data, $scope) {
        void 0;
        if (typeof $.cookie('pop_orig_url') === 'undefined') {
            $.cookie('pop_orig_url', POP.Util.u(), {path: '/', domain: '.pop.co'});
        }
        $.cookie('pop_domain', data.domain, { path: '/', domain: '.pop.co' });
        $.cookie('pop_domain_id', data.domain_id, { path: '/', domain: '.pop.co' });
		
		// Trigger Facebook and Twitter Signup events if objects exist
		if( typeof _fbq !== "undefined" && typeof twttr !== "undefined" ){
			window._fbq.push(['track', '6016727410301', {'value':'0.00','currency':'USD'}]);
			twttr.conversion.trackPid('l4b31');	
		}

        setTimeout(function() {
			if($rootScope.modalServiceSignup === true)
			{
				//ok so this is a service reg.
				$location.url('/modal/percolator');
				$rootScope.$apply();
			} else {
				window.location = '/percolating';
			}
        }, 3000);
    };

    /**
     * Handle logging in under certain circumstances.
     */
    validationHelper.login = function(data) {
        // unset old login cookies
        //$.removeCookie('pop_domain_id', { path: '/', domain: '.pop.co' });
        //$.removeCookie('pop_domain', { path: '/', domain: '.pop.co' });
        //$.removeCookie('pop_weasel', { path: '/', domain: '.pop.co' });
		//$.cookie('pop_domain', "", { path: '/', expires: -5, domain: '.pop.co' });
		//$.cookie('pop_weasel', "", { path:'/', expires: -5, domain:'.pop.co' });

        $.cookie('pop_domain', data.domain, { path: '/', domain: '.pop.co' });
        $.cookie('pop_domain_id', data.domain_id, { path: '/', domain: '.pop.co' });
        $.cookie('pop_weasel', data.token, { path: '/', domain: '.pop.co' });
    };

    /**
     * Given the scope, a deferred, and a response, handle generating a
     * response error message and flag any erroneous fields with their
     * accompanying validation errors.
     */
    validationHelper.generateRejectResponse = function($scope, deferred, response) {
        if (response.errors) {
			deferred.resolve(response);
        } else if (response.msg) {
            deferred.resolve({
                code: 500,
                msg: response.msg
            });
        } else {
            deferred.resolve({
                code: 500,
                msg: 'An unknown error has occurred on the backend. Please try again.'
            });
        }
    };

    return validationHelper;
}]);
